/**
 * Room Decoration Drawing Utilities
 * Extracted from Nightclub.js for cleaner code organization
 * All functions are pure canvas drawing operations
 */

export const drawVelvetRopes = (ctx, W, H, floorY, accentColor) => {
  const postHeight = 60;
  const ropeY = floorY + 80;
  ctx.fillStyle = '#FCD34D';
  ctx.shadowColor = '#FCD34D';
  ctx.shadowBlur = 10;
  ctx.fillRect(40, ropeY, 8, postHeight);
  ctx.fillRect(140, ropeY, 8, postHeight);
  ctx.strokeStyle = '#DC2626';
  ctx.lineWidth = 4;
  ctx.beginPath();
  ctx.moveTo(44, ropeY + 15);
  ctx.quadraticCurveTo(92, ropeY + 30, 144, ropeY + 15);
  ctx.stroke();
  ctx.fillRect(W - 48, ropeY, 8, postHeight);
  ctx.fillRect(W - 148, ropeY, 8, postHeight);
  ctx.beginPath();
  ctx.moveTo(W - 44, ropeY + 15);
  ctx.quadraticCurveTo(W - 92, ropeY + 30, W - 144, ropeY + 15);
  ctx.stroke();
  ctx.shadowBlur = 0;
};

export const drawChandeliers = (ctx, W, phase, audio) => {
  const chandelierY = 30;
  const crystalGlow = 0.5 + audio * 0.5;
  ctx.fillStyle = '#FCD34D';
  ctx.shadowColor = '#FCD34D';
  ctx.shadowBlur = 20 + audio * 15;
  ctx.strokeStyle = '#FCD34D';
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(W / 2, 0);
  ctx.lineTo(W / 2, chandelierY);
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(W / 2, chandelierY + 15, 25, 0, Math.PI * 2);
  ctx.fill();
  for (let i = 0; i < 8; i++) {
    const angle = (i / 8) * Math.PI * 2 + phase * 0.02;
    const cx = W / 2 + Math.cos(angle) * 20;
    const cy = chandelierY + 15 + Math.sin(angle) * 20;
    ctx.globalAlpha = crystalGlow;
    ctx.beginPath();
    ctx.arc(cx, cy, 5, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.globalAlpha = 1;
  ctx.shadowBlur = 0;
};

export const drawEquipmentCases = (ctx, W, H, floorY) => {
  const caseW = 60;
  const caseH = 40;
  const caseY = floorY + 150;
  ctx.fillStyle = '#1F2937';
  ctx.fillRect(30, caseY, caseW, caseH);
  ctx.fillRect(30, caseY + 50, caseW, caseH);
  ctx.strokeStyle = '#6B7280';
  ctx.lineWidth = 2;
  ctx.strokeRect(30, caseY, caseW, caseH);
  ctx.strokeRect(30, caseY + 50, caseW, caseH);
  ctx.fillStyle = '#374151';
  ctx.fillRect(45, caseY - 5, 30, 5);
  ctx.fillRect(45, caseY + 45, 30, 5);
  ctx.fillStyle = '#1F2937';
  ctx.fillRect(W - 90, caseY, caseW, caseH);
  ctx.fillRect(W - 90, caseY + 50, caseW, caseH);
  ctx.strokeRect(W - 90, caseY, caseW, caseH);
  ctx.strokeRect(W - 90, caseY + 50, caseW, caseH);
  ctx.font = 'bold 10px monospace';
  ctx.fillStyle = '#9CA3AF';
  ctx.fillText('FRAGILE', 40, caseY + 25);
  ctx.fillText('AUDIO', W - 80, caseY + 25);
};

export const drawCables = (ctx, W, H, floorY) => {
  ctx.strokeStyle = '#374151';
  ctx.lineWidth = 3;
  ctx.beginPath();
  ctx.moveTo(0, floorY + 100);
  ctx.quadraticCurveTo(W * 0.3, floorY + 120, W * 0.5, floorY + 90);
  ctx.stroke();
  ctx.strokeStyle = '#1F2937';
  ctx.beginPath();
  ctx.moveTo(W, floorY + 150);
  ctx.quadraticCurveTo(W * 0.7, floorY + 180, W * 0.4, floorY + 140);
  ctx.stroke();
  ctx.fillStyle = '#6B7280';
  ctx.beginPath();
  ctx.arc(W * 0.5, floorY + 90, 6, 0, Math.PI * 2);
  ctx.fill();
  ctx.beginPath();
  ctx.arc(W * 0.4, floorY + 140, 6, 0, Math.PI * 2);
  ctx.fill();
};

export const drawLoungeSeating = (ctx, W, H, floorY, accentColor) => {
  const sofaY = floorY + 120;
  ctx.fillStyle = '#1F2937';
  ctx.beginPath();
  ctx.moveTo(20, sofaY);
  ctx.quadraticCurveTo(80, sofaY - 30, 140, sofaY);
  ctx.lineTo(140, sofaY + 40);
  ctx.quadraticCurveTo(80, sofaY + 20, 20, sofaY + 40);
  ctx.closePath();
  ctx.fill();
  ctx.strokeStyle = accentColor;
  ctx.lineWidth = 2;
  ctx.globalAlpha = 0.5;
  ctx.beginPath();
  ctx.moveTo(30, sofaY + 5);
  ctx.quadraticCurveTo(80, sofaY - 15, 130, sofaY + 5);
  ctx.stroke();
  ctx.globalAlpha = 1;
  ctx.fillStyle = '#1F2937';
  ctx.beginPath();
  ctx.moveTo(W - 20, sofaY);
  ctx.quadraticCurveTo(W - 80, sofaY - 30, W - 140, sofaY);
  ctx.lineTo(W - 140, sofaY + 40);
  ctx.quadraticCurveTo(W - 80, sofaY + 20, W - 20, sofaY + 40);
  ctx.closePath();
  ctx.fill();
  ctx.globalAlpha = 0.5;
  ctx.beginPath();
  ctx.moveTo(W - 30, sofaY + 5);
  ctx.quadraticCurveTo(W - 80, sofaY - 15, W - 130, sofaY + 5);
  ctx.stroke();
  ctx.globalAlpha = 1;
};

export const drawRoomGraffiti = (ctx, W, H, graffiti, accentColor) => {
  ctx.font = 'bold 16px monospace';
  ctx.fillStyle = accentColor;
  ctx.globalAlpha = 0.3;
  if (graffiti[0]) ctx.fillText(graffiti[0], 30, 180);
  if (graffiti[1]) ctx.fillText(graffiti[1], W - 90, 180);
  if (graffiti[2]) {
    ctx.font = 'bold 12px monospace';
    ctx.fillText(graffiti[2], 50, 195);
  }
  ctx.globalAlpha = 1;
};

// ==================== ROOM OVERHAUL DECOR ====================

// Flickering neon sign (rooftop "SKY BAR", backstage "ON AIR", etc.)
export const drawNeonSign = (ctx, x, y, text, color, phase) => {
  const flicker = Math.sin(phase * 0.11) > -0.92 ? 1 : 0.35;
  ctx.save();
  ctx.font = 'bold 22px monospace';
  ctx.textAlign = 'center';
  ctx.shadowColor = color;
  ctx.shadowBlur = 18 * flicker;
  ctx.fillStyle = color;
  ctx.globalAlpha = 0.9 * flicker;
  ctx.fillText(text, x, y);
  ctx.globalAlpha = 0.25 * flicker;
  ctx.strokeStyle = color;
  ctx.lineWidth = 1;
  ctx.strokeRect(x - text.length * 7.5, y - 22, text.length * 15, 32);
  ctx.restore();
};

// Cozy fire pit with animated flames + warm glow
export const drawFirePit = (ctx, x, y, phase) => {
  ctx.save();
  const warm = ctx.createRadialGradient(x, y - 8, 4, x, y - 8, 70);
  warm.addColorStop(0, 'rgba(255, 140, 40, 0.28)');
  warm.addColorStop(1, 'transparent');
  ctx.fillStyle = warm;
  ctx.beginPath();
  ctx.arc(x, y - 8, 70, 0, Math.PI * 2);
  ctx.fill();
  // stone ring
  ctx.fillStyle = '#4b5563';
  ctx.beginPath();
  ctx.ellipse(x, y, 26, 10, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#374151';
  ctx.beginPath();
  ctx.ellipse(x, y - 2, 20, 7, 0, 0, Math.PI * 2);
  ctx.fill();
  // flames
  const t = phase * 0.09;
  [[-8, 0], [0, 1.7], [8, 0.9]].forEach(([ox, ph], i) => {
    const fh = 14 + Math.abs(Math.sin(t + ph)) * 10;
    const grad = ctx.createLinearGradient(x + ox, y - 2, x + ox, y - 2 - fh);
    grad.addColorStop(0, 'rgba(255, 80, 0, 0.9)');
    grad.addColorStop(0.6, 'rgba(255, 160, 20, 0.85)');
    grad.addColorStop(1, 'rgba(255, 240, 120, 0.5)');
    ctx.fillStyle = grad;
    ctx.beginPath();
    ctx.moveTo(x + ox - 6, y - 2);
    ctx.quadraticCurveTo(x + ox - 3 + Math.sin(t * 2 + i) * 3, y - 2 - fh * 0.6, x + ox + Math.sin(t * 3 + i) * 2, y - 2 - fh);
    ctx.quadraticCurveTo(x + ox + 4, y - 2 - fh * 0.5, x + ox + 6, y - 2);
    ctx.fill();
  });
  // embers
  for (let i = 0; i < 4; i++) {
    const rise = (phase * 0.8 + i * 17) % 40;
    ctx.fillStyle = `rgba(255, 170, 60, ${0.8 - rise / 45})`;
    ctx.fillRect(x - 8 + (i * 13) % 18 + Math.sin(t + i) * 3, y - 6 - rise, 2, 2);
  }
  ctx.restore();
};

// Bubbling hot tub
export const drawHotTub = (ctx, x, y, phase) => {
  ctx.save();
  ctx.fillStyle = '#5b3a1e';
  ctx.beginPath();
  ctx.ellipse(x, y, 52, 20, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#7c4f28';
  ctx.beginPath();
  ctx.ellipse(x, y - 4, 48, 17, 0, 0, Math.PI * 2);
  ctx.fill();
  const water = ctx.createRadialGradient(x, y - 5, 4, x, y - 5, 44);
  water.addColorStop(0, '#67e8f9');
  water.addColorStop(1, '#0e7490');
  ctx.fillStyle = water;
  ctx.beginPath();
  ctx.ellipse(x, y - 5, 42, 13, 0, 0, Math.PI * 2);
  ctx.fill();
  // bubbles + steam
  const t = phase * 0.06;
  for (let i = 0; i < 7; i++) {
    const bx = x - 30 + (i * 23) % 60 + Math.sin(t + i) * 4;
    const by = y - 5 + Math.sin(t * 2 + i * 2) * 5;
    ctx.fillStyle = 'rgba(255,255,255,0.5)';
    ctx.beginPath();
    ctx.arc(bx, by, 1.5 + Math.abs(Math.sin(t * 3 + i)) * 1.5, 0, Math.PI * 2);
    ctx.fill();
  }
  for (let i = 0; i < 3; i++) {
    const rise = (phase * 0.5 + i * 25) % 55;
    ctx.fillStyle = `rgba(255,255,255,${0.18 * (1 - rise / 55)})`;
    ctx.beginPath();
    ctx.arc(x - 20 + i * 20 + Math.sin(t + i * 2) * 6, y - 12 - rise, 7 + rise * 0.15, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.restore();
};

// Soaking overlay — water line, steam and name tag over a clipped avatar in the tub
export const drawTubSoakOverlay = (ctx, x, y, phase, name) => {
  const t2 = phase * 0.05;
  ctx.save();
  ctx.fillStyle = 'rgba(56,189,248,0.75)';
  ctx.beginPath(); ctx.ellipse(x, y - 26 + Math.sin(t2 * 2) * 1.5, 27, 7, 0, 0, Math.PI * 2); ctx.fill();
  ctx.strokeStyle = 'rgba(255,255,255,0.5)'; ctx.lineWidth = 1.5;
  ctx.beginPath(); ctx.ellipse(x, y - 28, 22, 5, 0, 0, Math.PI * 2); ctx.stroke();
  for (let i = 0; i < 4; i++) {
    const rise = (phase * 0.55 + i * 22) % 70;
    ctx.fillStyle = `rgba(255,255,255,${Math.max(0, 0.3 - rise / 300)})`;
    ctx.beginPath();
    ctx.arc(x - 18 + i * 12 + Math.sin(t2 * 1.6 + i * 1.8) * 7, y - 64 - rise, 6 + rise * 0.15, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.font = '13px serif';
  ctx.fillStyle = `rgba(255,255,255,${Math.max(0.15, 0.5 + Math.sin(t2 * 3) * 0.4)})`;
  ctx.fillText('♨', x + 28, y - 72 - Math.sin(t2 * 2) * 4);
  if (name) {
    ctx.font = 'bold 11px sans-serif';
    ctx.textAlign = 'center';
    ctx.fillStyle = '#fff';
    ctx.shadowColor = '#000';
    ctx.shadowBlur = 4;
    ctx.fillText(name, x, y + 20);
    ctx.shadowBlur = 0;
  }
  ctx.restore();
};

// Backlit VIP bar shelf with glowing bottles
export const drawBarShelf = (ctx, x, y, phase) => {
  ctx.save();
  ctx.fillStyle = '#2a1d14';
  ctx.fillRect(x, y, 130, 74);
  ctx.strokeStyle = '#FCD34D';
  ctx.globalAlpha = 0.5;
  ctx.strokeRect(x, y, 130, 74);
  ctx.globalAlpha = 1;
  const bottleColors = ['#22d3ee', '#f472b6', '#a3e635', '#fbbf24', '#a78bfa', '#f87171'];
  for (let shelf = 0; shelf < 2; shelf++) {
    const sy = y + 30 + shelf * 34;
    ctx.fillStyle = '#3f2d1d';
    ctx.fillRect(x + 4, sy, 122, 4);
    for (let i = 0; i < 6; i++) {
      const bx = x + 14 + i * 19;
      const c = bottleColors[(i + shelf * 3) % bottleColors.length];
      const glow = 0.55 + Math.abs(Math.sin(phase * 0.04 + i + shelf)) * 0.45;
      ctx.fillStyle = c;
      ctx.globalAlpha = glow;
      ctx.fillRect(bx, sy - 20, 8, 20);
      ctx.fillRect(bx + 2.5, sy - 26, 3, 6);
      ctx.globalAlpha = 1;
    }
  }
  ctx.fillStyle = '#FCD34D';
  ctx.font = 'bold 11px monospace';
  ctx.textAlign = 'center';
  ctx.shadowColor = '#FCD34D';
  ctx.shadowBlur = 8;
  ctx.fillText('VIP BAR', x + 65, y + 16);
  ctx.shadowBlur = 0;
  ctx.restore();
};

// Champagne tower for the VIP lounge
export const drawChampagneTower = (ctx, x, y, phase) => {
  ctx.save();
  ctx.fillStyle = '#d1d5db';
  ctx.fillRect(x - 34, y, 68, 6);
  const rows = [4, 3, 2, 1];
  rows.forEach((count, ri) => {
    const gy = y - 8 - ri * 14;
    for (let i = 0; i < count; i++) {
      const gx = x - (count - 1) * 7 + i * 14;
      ctx.fillStyle = 'rgba(253, 230, 138, 0.85)';
      ctx.beginPath();
      ctx.moveTo(gx - 5, gy - 10);
      ctx.lineTo(gx + 5, gy - 10);
      ctx.lineTo(gx + 1.5, gy - 2);
      ctx.lineTo(gx + 1, gy + 4);
      ctx.lineTo(gx + 3, gy + 5);
      ctx.lineTo(gx - 3, gy + 5);
      ctx.lineTo(gx - 1, gy + 4);
      ctx.lineTo(gx - 1.5, gy - 2);
      ctx.closePath();
      ctx.fill();
      const sp = Math.abs(Math.sin(phase * 0.07 + i + ri * 2));
      if (sp > 0.75) {
        ctx.fillStyle = 'rgba(255,255,255,0.9)';
        ctx.fillRect(gx - 1, gy - 14, 2, 2);
      }
    }
  });
  ctx.restore();
};
